export const DISMISS_ERROR = 'dismiss-account-errors';
const dismissError = ({ error }) => ({ type: DISMISS_ERROR, payload: { error } });
export default dismissError;
